import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ToasterService } from '../toaster/toaster.service';
import { DownloadService } from '../../../_services/download';

@Injectable()
export class DownloadWithToastsService {
    constructor(
        private downloadService: DownloadService,
        private toasterService: ToasterService,
        private translateService: TranslateService
    ) {}

    async downloadAndOpenDocument(
        url: string,
        type: string,
        fileName?: string
    ) {
        this.toasterService.success(
            this.translateService.instant('global.download.start')
        );
        await this.downloadService.downloadAndOpenDocument(url, type, fileName);
        this.toasterService.success(
            this.translateService.instant('global.download.success')
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/download-with-toasts/download-with-toasts.service.ts